import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { TbLoader3 } from "react-icons/tb";
import { useParams, useNavigate } from "react-router-dom";
import { Rating, Textarea, Button, Typography, Breadcrumbs } from "@material-tailwind/react";
import { toast } from "sonner";
import { IoArrowBack } from "react-icons/io5";
import axios from "axios";

const Reviews = () => {
  const { orden, producto, grupo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    articulo: [],
  });

  useEffect(() => {
    const cliente = JSON.parse(localStorage.getItem("eyJhbGciOiJIUzI1NiJ9"));
    fetch(
      "https://muebleria-villarreal.com/apimv/articuloReviewController.php?grupo=" +
        grupo +
        "&articulo=" +
        producto +
        "&orden=" +
        orden
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.checkReview) {
          alert("Ya has realizado una reseña para este producto");
          navigate("/cliente");
        } else if (data.articulo.length == 0) {
          alert("No se encontró el producto");
          navigate("/cliente");
        } else {
          setData(data.articulo[0]);
        }
        // console.log('Full API Response:', data);
        // console.log('Check Review Data:', data.checkReview);
        // console.log(data);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      });
  }, [grupo, producto]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (rating === 0) {
      toast.error("Por favor selecciona una calificación");
      return;
    }

    if (review.trim().length < 10) {
      toast.error("Por favor escribe una reseña de al menos 10 caracteres");
      return;
    }

    setSubmitting(true);

    try {
      setLoading(true);
      const cliente = JSON.parse(localStorage.getItem("eyJhbGciOiJIUzI1NiJ9"));
      // axios.post('/api2/reviewController.php', {
      axios.post('https://muebleria-villarreal.com/apimv/reviewController.php', {
        producto: producto,
        orden_vta: orden,
        usuario: cliente.nombre_completo,
        rating: rating,
        review: review,
        visible: 1
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: false
      });
      // console.log('Response:', response.data);

      if (response.data.success) {
        toast.success("¡Gracias por tu reseña!");
        setTimeout(() => {
          navigate("/cliente");
        }, 1000);
      } else {
        toast.error(response.data.message || "Error al enviar la reseña");
      }
    } catch (error) {
      // console.error('Error details:', {
      //   message: error.message,
      //   response: error.response?.data,
      //   status: error.response?.status,
      //   config: error.config
      // });
      
      if (error.code === 'ECONNABORTED') {
        toast.error("La solicitud tardó demasiado tiempo. Por favor, intenta de nuevo.");
      } else if (!error.response) {
        toast.error("No se pudo conectar con el servidor. Por favor, verifica tu conexión.");
      } else {
        toast.error(error.response?.data?.message || "Error al enviar la reseña");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <section className="w-full min-h-[80dvh] flex flex-col items-center justify-center relative py-12">
        {loading && (
          <div className="w-full h-[80dvh] bg-white bg-opacity flex justify-center items-center absolute top-0 left-0 z-20">
            <TbLoader3 className="stroke-azul animate-spin h-20 w-20" />
          </div>
        )}
        
        <div className="w-full max-w-2xl px-4">
          <Button
            variant="text"
            className="flex items-center gap-2 text-azul hover:text-azul/80 mb-4"
            onClick={() => navigate("/cliente")}
          >
            <IoArrowBack className="h-5 w-5" />
            Volver
          </Button>

          <Typography variant="h2" className="text-2xl font-bold text-azul pb-6 text-center mt-5">
            Califica tu Compra
          </Typography>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Typography variant="small" className="text-gray-700">
                Pedido: {orden}
              </Typography>
              <Typography variant="small" className="text-gray-700">
                Producto: {data?.descripcion_corta}
              </Typography>
              <img src={`https://s3.us-east-2.amazonaws.com/cdn.muebleriavillarreal/mvcweb/images/articulos_img/${data?.departamento}/${data?.articulo}.jpg?quality=auto&format=webp`} alt={data?.descripcion_corta} className="size-40" />
            </div>

            <div className="space-y-2">
              <Typography variant="small" className="text-gray-700">
                Calificación
              </Typography>
              <Rating
                value={rating}
                onChange={(value) => setRating(value)}
                className="text-amber-500"
              />
            </div>

            <div className="space-y-2">
              <Typography variant="small" className="text-gray-700">
                Tu Reseña
              </Typography>
              <Textarea
                value={review}
                onChange={(e) => setReview(e.target.value)}
                label="Cuéntanos sobre tu experiencia con el producto..."
                className="min-h-[150px]"
              />
            </div>

            <Button
              type="submit"
              disabled={submitting}
              className="w-full bg-azul"
            >
              {submitting ? "Enviando..." : "Enviar Reseña"}
            </Button>
          </form>
        </div>
      </section>
    </Layout>
  );
};

export default Reviews;
